import styled, { css } from 'styled-components';
import { layout } from '@prisjakt/ui-base';
import { switchProp } from 'styled-tools';

type WarningProp = { warning?: boolean };
const sharedInputStyle = css<WarningProp>`
  width: 100%;
  background: ${p => p.theme.inputs.primary.bg};
  padding: ${layout.measurements.spacingSmall};
  border: 1px solid ${p => p.theme.inputs.primary.border};
  outline: 0;
  ${props =>
    props.warning &&
    css`
      border-color: ${p => p.theme.text.negative};
    `}

  &:focus {
    border-color: ${p => p.theme.inputs.primary.borderFocus};
    box-shadow: inset 0 0 0 1px ${p => p.theme.inputs.primary.borderFocus};
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

type InputProps = { variant: 'default' | 'rounded' };
export const Input = styled.input<InputProps & WarningProp>`
  ${sharedInputStyle};

  ${switchProp('variant', {
    rounded: css`
      border-radius: 4px;
    `,
  })}
`;

export const TextArea = styled.textarea`
  ${sharedInputStyle};
  resize: vertical;
`;

export const Label = styled.label`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const LabelText = styled.span`
  cursor: pointer;
  user-select: none;
`;

export const Helper = styled.span<WarningProp>`
  font-size: ${layout.measurements.fontSizeNormal};
  color: ${p => p.theme.text.tertiary};
  width: 100%;

  ${props =>
    props.warning &&
    css`
      color: ${p => p.theme.text.negative};
    `}
`;
